const translation = {

}
export { translation }